<template>
    <mds-layout-grid>
        <mds-row e2e="benchmark-summary">
            <mds-col :cols="3">
                <div class="summary-label">{{ getUILabel("settings_benchmark_method") }}</div>
                <div class="summary-text">{{ benchmarkMethod }}</div>
            </mds-col>
        </mds-row>
    </mds-layout-grid>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import { mapState, mapGetters } from "vuex";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";

export default {
    name: "benchmark-summary",
    components: {
        MdsLayoutGrid,
        MdsRow,
        MdsCol
    },
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    data() {
        return {
            defaultConfig: {
                labels: this.$store.state.labels.labels
            }
        };
    },
    computed: {
        ...mapState("benchmark", ["benchmarkType"]),
        ...mapGetters("benchmark", ["benchmarkTypes"]),
        benchmarkMethod() {
            const selectedBenchmarkOption = this.benchmarkTypes.find(i => i.id === this.benchmarkType);
            return selectedBenchmarkOption && this.getUILabel(selectedBenchmarkOption.labelId);
        }
    }
};
</script>
